<script>

import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from "sweetalert2";
import moment from "moment";

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  components: {

  },
  props: {
    formapgtosList: {
      type: Array,
      default: function () {
        return [];
      },
    }
    ,
    codpagtoList: {
      type: Array,
      default: function () { return []; }
    }
  },
  validations: {
    regSelecionado :{
      descricao: {
        required: helpers.withMessage("Campo descrição obrigatório, favor preencher.", required),
      },
      status: {
        required: helpers.withMessage("Campo status obrigatório, favor preencher.", required),
      },
      codigo: {
        required: helpers.withMessage("Campo código obrigatório, favor preencher.", required),
      },
    }
  },
  mounted() {
    // console.log('mounted formas-table_0')
    // console.log(this.updating)
  },
  methods: {

    nomeStatus(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'A':
          result = 'Ativo'
          break
        default:
          result = 'Inativo'
          break
      }
      return result
    },

    editar(dataID){
      console.log('editar: ' + dataID)
      this.showModal = true
      this.regSelecionado = this.formapgtosList.find((reg) => reg.id === dataID);
      console.log('regSelecionado: ')
      console.log(this.regSelecionado)
    },

    deletar(dataID){
      console.log('deletar: ' + dataID)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.$emit('deletareg', dataID)
        }
      })
    },

    formSubmit() {
      console.log('formSubmit_0')
      this.submitted = true
      this.v$.$touch()
      if (this.v$.$invalid) {
        return;
      } else {
        console.log('formSubmit_validado')
        this.showModal = false
        this.$emit('alterareg', this.regSelecionado)
      }
    },

    setCriarNova: function() {
      this.regSelecionado = {
        status: 'A',
        possui_tx: false,
        valor_taxa: 0,
        percent_taxa: 0
      }
      this.submitted = false
      this.showModal = true

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return '0,00';
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },
  data() {
    return {
      regSelecionado: {},
      submitted: false,
      showModal: false,
    };
  },
};
</script>

<template>
  <div class="table-responsive mb-0">
    <table class="table align-middle table-nowrap" v-if="formapgtosList">
      <thead class="table-light">
      <tr>

        <th class="align-middle">ID</th>
        <th class="align-middle">Código</th>
        <th class="align-middle">Descrição</th>
        <th class="align-middle">Filtro Tabela</th>
        <th class="align-middle">Filtro Operação</th>
        <th class="align-middle">Último Pedido</th>
        <th class="align-middle text-end">Quantidade Mínima</th>
        <th class="align-middle text-end">Valor Mínimo</th>
        <th class="align-middle text-center">Possui Taxa</th>
        <th class="align-middle text-end">Valor Taxa</th>
        <th class="align-middle text-end">Perc. Taxa</th>
        <th class="align-middle">Status</th>
        <th class="align-middle">Ações</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="data in formapgtosList" :key="data.id">
        <td>
          <a href="javascript: void(0);" class="text-body fw-bold" @click="editar(data.id)">{{
              data.id
            }}</a>
        </td>
        <td>{{ data.codigo }} </td>
        <td>{{ data.descricao }} </td>
        <td>{{ data.telefone }} </td>
        <td> </td>
        <td>{{ formatDateTime(data.created_at) }} </td>
        <td class="text-end">{{ formatDecimal(data.qtdmin) }} </td>
        <td class="text-end">{{ formatDecimal(data.valormin) }} </td>
        <td class="text-center">
          <span
              class="badge badge-pill font-size-11"
              :class="data.possui_tx ? 'badge-soft-warning' : 'badge-soft-secondary'">
            {{ data.possui_tx ? 'Possui Taxa' : 'Sem Taxa' }}
          </span>
        </td>
        <td class="text-end">{{ formatDecimal(data.valor_taxa) }} </td>
        <td class="text-end">{{ formatDecimal(data.percent_taxa) }}%</td>

        <td>
              <span
                  class="badge badge-pill badge-soft-success font-size-11"
                  :class="data.status === 'A' ? 'badge-soft-success' : 'badge-soft-danger'">
                {{ nomeStatus(data.status)  }}
              </span>
        </td>

        <td>
          <div class="button-items">
            <b-button variant="outline-success" @click="editar(data.id)">
              <i class="mdi mdi-pencil d-block font-size-16"></i>
            </b-button>
            <b-button variant="outline-danger" @click="deletar(data.id)">
              <i class="mdi mdi-trash-can d-block font-size-16"></i>
            </b-button>
          </div>
        </td>

      </tr>
      </tbody>
    </table>

    <b-modal :title="regSelecionado.id != null ? `Editar Forma de Pagamento (${ regSelecionado.id })` : 'Criar Nova Forma de Pagamento'" v-model="showModal" hide-footer>
      <form @submit.prevent="formSubmit">
        <div class="row">

          <div class="col-12">
            <h5 class="text-primary mb-3">Informações Gerais</h5>
          </div>

          <div class="col-md-12">
            <div class="mb-3">
              <label for="descricao" class="form-label">Descrição</label>
              <input
                  id="descricao"
                  v-model="regSelecionado.descricao"
                  type="text"
                  class="form-control"
                  placeholder="Inserir descrição"
                  :class="{'is-invalid': submitted && v$.regSelecionado.descricao.$error,}"/>
              <div
                  v-if="submitted && v$.regSelecionado.descricao.$error"
                  class="invalid-feedback">
                <span v-if="v$.regSelecionado.descricao.required.$message">
                  {{ v$.regSelecionado.descricao.required.$message }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="mb-3">
              <label for="codpgtoid" class="form-label">Código Interno</label>
              <b-form-select
                  id="codpgtoid"
                  v-model="regSelecionado.codpgtoid"
                  class="form-select"
                  :class="{'is-invalid': submitted && v$.regSelecionado.codigo.$error,}">
                <b-form-select-option
                    v-for="opt in codpagtoList"
                    :key="opt.id"
                    :value="opt.id">
                  {{ opt.descricao }}
                </b-form-select-option>
              </b-form-select>
              <div
                  v-if="submitted && v$.regSelecionado.codigo.$error"
                  class="invalid-feedback">
                <span v-if="v$.regSelecionado.codigo.required.$message">
                  {{ v$.regSelecionado.codigo.required.$message }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="mb-3">
              <label for="codigo" class="form-label">Código</label>
              <input
                  id="codigo"
                  v-model="regSelecionado.codigo"
                  type="text"
                  class="form-control"
                  placeholder="Cód."
                  :class="{'is-invalid': submitted && v$.regSelecionado.codigo.$error,}"/>
              <div
                  v-if="submitted && v$.regSelecionado.codigo.$error"
                  class="invalid-feedback">
                <span v-if="v$.regSelecionado.codigo.required.$message">
                  {{ v$.regSelecionado.codigo.required.$message }}
                </span>
              </div>
            </div>
          </div>
          
          <div class="col-md-3">
            <div class="mb-3">
              <label for="selectStatus" class="form-label">Status</label>
              <b-form-select
                  id="selectStatus"
                  v-model="regSelecionado.status"
                  class="form-select"
                  :class="{'is-invalid': submitted && v$.regSelecionado.status.$error,}">
                <b-form-select-option value="A">
                  Ativo
                </b-form-select-option>
                <b-form-select-option value="I">
                  Inativo
                </b-form-select-option>
                <b-form-select-option value="L">
                  Análise
                </b-form-select-option>
              </b-form-select>
              <div v-if="submitted && v$.regSelecionado.status.$error" class="invalid-feedback">
                <span v-if="v$.regSelecionado.status.required.$message">
                  {{ v$.regSelecionado.status.required.$message }}
                </span>
              </div>

            </div>
          </div>

          <div class="col-12 mt-3">
            <h5 class="text-primary mb-3">Configurações Financeiras</h5>
            <div class="d-flex align-items-center mb-3">
              <b-form-checkbox
                  id="possuiTaxa"
                  v-model="regSelecionado.possui_tx"
                  switch
                  class="me-2"
              >
                Forma de pagamento possui taxa?
              </b-form-checkbox>
            </div>
          </div>

        <div class="col-md-6" v-if="regSelecionado.possui_tx">
            <div class="mb-3">
              <label for="valorTaxa" class="form-label">Valor da Taxa (Fixo)</label>
              <div class="input-group">
                <span class="input-group-text">R$</span>
                <input
                    id="valorTaxa"
                    v-model.number="regSelecionado.valor_taxa"
                    type="number"
                    step="0.01"
                    class="form-control"
                    placeholder="0,00"
                />
              </div>
              <small class="text-muted">Preencha se houver um valor fixo cobrado.</small>
            </div>
          </div>

          <div class="col-md-6" v-if="regSelecionado.possui_tx">
            <div class="mb-3">
              <label for="percTaxa" class="form-label">Percentual da Taxa (%)</label>
              <div class="input-group">
                <input
                    id="percTaxa"
                    v-model.number="regSelecionado.percent_taxa"
                    type="number"
                    step="0.01"
                    class="form-control"
                    placeholder="0,00"
                />
                <span class="input-group-text">%</span>
              </div>
              <small class="text-muted">Preencha se houver um percentual fixo cobrado.</small>
            </div>
          </div>

        </div>

        <div class="d-flex justify-content-end mt-4 pt-3 border-top">
          <b-button variant="light" class="me-2" @click="showModal = false">
            Cancelar
          </b-button>
          <b-button variant="primary" @click="formSubmit">
            <i class="bx bx-save font-size-16 align-middle me-2"></i>
            Salvar Alterações
          </b-button>
        </div>

      </form>

    </b-modal>
  </div>

</template>
